import { useFormat } from '@ideavivat/vivat-2';

export default {
  types: {
    _primaryControls: {
      width: '3rem',
    },
    _secondaryControls: {
      width: '2rem',
    },
    _increment: {
      name: 'ลำดับ',
      width: '4rem',
    },
    _playPauseControls: {
      width: '3rem',
    },
    // eslint-disable-next-line
    scheduled_time: {
      name: 'วันที่',
      width: '10rem',
      filter(val: any) {
        return useFormat.date(val).displayShortThaiDateTime();
      },
    },
    // eslint-disable-next-line
    start_time: {
      name: 'เวลาเริ่ม',
      width: '6rem',
    },
    // eslint-disable-next-line
    end_time: {
      name: 'เวลาสิ้นสุด',
      width: '6rem',
    },
    speakers: {
      name: 'ผู้พูด',
      width: '2fr',
      filter(val: any[]) {
        let display = '';
        val.forEach((speaker, index: number) => {
          if (index === 0) display = `${speaker.name}`;
          display = `${display}, ${speaker.name}`;
        });
        return display;
      },
      class: 'overflow-ellipsis',
    },
    name: {
      name: 'หัวข้อ',
      width: '2fr',
    },
    text: {
      name: 'รายละเอียด',
      width: '12rem',
    },
    file: {
      name: 'ไฟล์โหลด',
      width: '8rem',
    },
  },
};
